import { ActionWithPayload } from "@obg/ngrx-utils";
import { forEach, isEmpty } from "lodash-es";

import { GAME_COLLECTION_ACTION_TYPE } from "./game-collection.action";
import { GameCollectionRaw, GameCollectionState } from "./game-collection.model";

const INITIAL_STATE: GameCollectionState = {
	isBusy: false,
	gameCollections: {},
	slugs: {},
};

export function gameCollectionReducer(state = INITIAL_STATE, action: ActionWithPayload): GameCollectionState {
	switch (action.type) {
		case GAME_COLLECTION_ACTION_TYPE.getAll:
		case GAME_COLLECTION_ACTION_TYPE.getById: {
			return Object.assign({}, state, {
				isBusy: true,
			});
		}
		case GAME_COLLECTION_ACTION_TYPE.getAllSuccess: {
			if (isEmpty(action.payload)) {
				return state;
			}

			const slugs = getSlugs(action);

			return Object.assign({}, state, {
				isBusy: false,
				gameCollections: action.payload,
				slugs,
			});
		}
		case GAME_COLLECTION_ACTION_TYPE.getByIdSuccess: {
			if (isEmpty(action.payload)) {
				return state;
			}

			const getByIdSlugs = getSlugs(action);

			return Object.assign({}, state, {
				isBusy: false,
				gameCollections: { ...state.gameCollections, ...action.payload },
				slugs: { ...state.slugs, ...getByIdSlugs },
			});
		}
		case GAME_COLLECTION_ACTION_TYPE.getAllFail:
		case GAME_COLLECTION_ACTION_TYPE.getByIdFail: {
			return Object.assign({}, state, {
				isBusy: false,
			});
		}
		default:
			return state;
	}
}

export function getSlugs(action: ActionWithPayload): Record<string, string> {
	const slugs: Record<string, string> = {};
	forEach<GameCollectionRaw>(action.payload, (collection) => (slugs[collection.slug] = collection.id));
	return slugs;
}
